import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-bulk-refund',
		path: '/admin/p/:slug/bulk_refund',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-bulkRefunds" */ './index'), {
			exportName: 'BulkRefund',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
	},
];
